// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"f223dafb","287":"4e994e38","453":"151bd1c8"}[chunkId] + ".chunk.js";
};